import React from 'react';

import { Props } from './types';

const getInitials = (name: string): string => {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0][0]?.toUpperCase() ?? '?';
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

// Deterministic hue from the name so the same person always gets the same color.
const getHue = (name: string): number => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash) % 360;
};

/**
 * @deprecated Do not use this component. Use the base components at the root of the UI folder instead.
 */
const Avatar: React.FC<Props> = ({ avatarUrl, name = 'User', size = 'medium', className = '' }) => {
  const sizeClasses = {
    small: 'w-6 h-6 text-xs',
    medium: 'w-8 h-8 text-sm'
  };

  const borderClasses =
    size === 'small'
      ? 'rounded-full border border-white'
      : 'rounded-full border-2 border-white shadow-sm';

  if (avatarUrl) {
    return (
      <img
        className={`${sizeClasses[size]} ${borderClasses} ${className}`}
        src={avatarUrl}
        alt={name}
        title={name}
      />
    );
  }

  const initials = getInitials(name);
  const hue = getHue(name);

  return (
    <div
      role="img"
      className={`${sizeClasses[size]} ${borderClasses} ${className} flex items-center justify-center font-semibold text-white select-none`}
      style={{ backgroundColor: `hsl(${hue}, 55%, 45%)` }}
      title={name}
      aria-label={name}>
      <span aria-hidden="true">{initials}</span>
    </div>
  );
};

export default Avatar;
